// extracted by mini-css-extract-plugin
export var htmlPreview = "_vr-0";